"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsNamespaceProvider = void 0;
var _react = require("react");
var _TranslationsProvider = require("../TranslationsProvider");
var _translationsNamespaceContext = require("./translationsNamespaceContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Props for the TranslationsNamespaceProvider component.
 */

/**
 * Provider which provides translations namespace context to its children.
 *
 * @param props The namespace configuration for which translations are being provided.
 */
const TranslationsNamespaceProvider = ({
  namespace,
  children
}) => {
  /**
   * Checks if the provided namespace exists in the translationsWithNamespaces object.
   * Throws an error if the namespace is not found.
   */
  const {
    translationsWithNamespaces
  } = (0, _react.useContext)(_TranslationsProvider.translationsContext);
  const namespaceExists = translationsWithNamespaces ? Object.hasOwn(translationsWithNamespaces, namespace) : false;
  if (!namespaceExists && translationsWithNamespaces && Object.values(translationsWithNamespaces).length > 0) {
    throw new Error(`Entered namespace ${namespace} does not exists in translations object ${JSON.stringify(translationsWithNamespaces)} in TranslationsProvider or provided namespace has no translations`);
  }
  const contextValue = (0, _react.useMemo)(() => ({
    namespace
  }), [namespace]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_translationsNamespaceContext.translationsNamespaceContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.TranslationsNamespaceProvider = TranslationsNamespaceProvider;
